import React, {Fragment} from 'react';
import {Layout, NavLink, Notes, Route, Switch} from 'components';

export function Router() {
  return (
    <Fragment>
      <Layout.Title>Notes</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink to="/notes/">Notes</NavLink>
      </Layout.Topbar.Tabs>
      <Notes.Sidebar />
      <main>
        <Switch>
          <Route path="/:module/add/" component={Notes.EditForm} />
          <Route path="/:module/:id(\d+)/" component={Notes.EditForm} />
          <Route component={Notes.Home} />
        </Switch>
      </main>
    </Fragment>
  );
}
